import styled from 'styled-components';
import { space, SpaceProps } from 'styled-system';
import { Text } from '~/components/typography';

export const Disclaimer = styled(Text).attrs({ color: 'secondary' })<SpaceProps>`
  ${space}
  font-size: small;
  opacity: medium;
  text-align: ${props => props.textAlign || 'center'};
`;

export const OregonDisclaimer = styled(Text).attrs({ color: 'secondary' })<SpaceProps>`
  ${space}
  font-size: small;
  opacity: medium;
  text-align: left;
  margin-top: 10px;
`;

export const OregonEmailLink = styled.a`
  color: #577671;
  cursor: pointer;
  font-size: small;
`;
